import request from '@/api/axios';

export const getDayWorkUserInfo = (params) => {
  return request({
    url: 'ding-ding/dd-work-user-info/get-day-work-user-info',
    method: 'get',
    params: {
      ...params,
    }
  })
}

export const getWorkUserList = (params) => {
  return request({
    url: 'ding-ding/dd-work-user-info/get-work-user-list',
    method: 'get',
    params: {
      ...params,
    }
  })
}

export const addWorkUserInfo = (row) => {
  return request({
     url: 'ding-ding/dd-work-user-info/add-work-user-info',
    method: 'post',
    data: row
  })
}
 
 export const delUserWorkInfo = (params) => {
   return request({
     url: 'ding-ding/dd-work-user-info/del-work-user-info',
     method: 'get',
     params: {
       ...params,
     }
   })
 }
  
